import * as searchActions from '../../store/search/actions'
import {connect} from 'react-redux'
import SearchPanel from '../../components/search-panel'

function mapStateToProps (state) {
  return {
    params: state.myForms.search.params,
    companies: state.myForms.search.companies,
    criteriaSets: state.myForms.search.criteriaSets,
    paramsLoader: state.myForms.search.paramsLoader,
    loader: state.myForms.search.loader,
    totalSize: state.myForms.search.totalSize,
    reqUrl: state.myForms.search.reqUrl,
    pageNo: state.myForms.search.pageNo,
    error: state.myForms.search.error,
    paramsError: state.myForms.search.paramsError,
    pageSize: state.myForms.search.pageSize,
    pageRange: state.myForms.search.pageRange,
    activeTab: state.myForms.search.activeTab,
    resTime: state.myForms.search.resTime,
    countryLoader: state.myForms.search.countryLoader,
    countryList: state.myForms.search.countryList,
  }
}

export default connect(mapStateToProps, searchActions)(SearchPanel)



// WEBPACK FOOTER //
// ./src/containers/search/search-panel-container.js